<p-dialog [(visible)]="ConsultationDialogFlag" [draggable]="false" [modal]="true" [resizable]="false" [closable]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '60vw' }" class="custom-dialog"
  [ngClass]="mode=='detail_c502' ? 'color-c502': ''">
  <!-- ヘッダー -->
  <ng-template pTemplate="header">
    <div class="header" *ngIf="mode!='detail_c502'"></div>
    <div class="header text-header" *ngIf="mode=='detail_c502'"> 相談内容 </div>
  </ng-template>

  <!-- コンテンツ -->
  <div class="content">
    <div class="p-fluid p-formgrid p-grid">
      <ng-container *ngIf="mode!='detail_c502'">
        <div class="p-col-12 pink-color-consult">
          <div class="first">{{ consultation?.municipalities + ' ' + consultation?.organization_name }}</div>
          <div class="last">{{ consultation?.oneword_message }}</div>
        </div>
        <div class="p-col-2">
          相談内容
        </div>
        <ng-container *ngIf="mode=='input'">
          <div class="p-col-10 input-text">
            <textarea pInputTextarea [(ngModel)]="consultationInput" maxlength="800" rows="8"
              autocomplete="off"></textarea>
          </div>
          <div class="p-col-12 button-group">
            <button pButton type="button" label="確認画面へ進む" [disabled]="isDisabledConsultation()"
              class="button-default-size button1" (click)="confirm()"></button>
          </div>
        </ng-container>
        <ng-container *ngIf="mode=='confirm'">
          <div class="p-col-10 input-text">
            <ng-container *ngFor="let subCon of getConsultationInput()">
              <p *ngIf="subCon.trim().length > 0">{{ subCon }}</p>
              <br *ngIf="subCon.trim().length == 0">
            </ng-container>
          </div>
          <div class="p-col-12 button-group">
            <button pButton type="button" label="登録する" class="button-default-size button1"
              (click)="addConsultation()"></button>
            <button pButton type="button" label="入力画面へ戻る" class="button-default-size button2"
              (click)="cancelConfirm()"></button>
          </div>
        </ng-container>
        <ng-container *ngIf="mode=='detail'">
          <div class="p-col-10 input-text">
            <p *ngFor="let subCon of getConsultationInput()">{{ subCon }}</p>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="mode=='detail_c502'">
        <!-- <div class="p-col-12 text-header">
          相談内容
        </div> -->
        <div class="p-col-12 input-text" *ngIf="consultationInput2 && consultationInput2 != ''">
          <textarea pInputTextarea [(ngModel)]="consultationInput2" maxlength="800" rows="8" readonly
            class="textarea-c502" autocomplete="off"></textarea>
        </div>
        <div class="p-col-12 input-text" *ngIf="consultationInput && consultationInput != ''">
          <textarea pInputTextarea [(ngModel)]="consultationInput" maxlength="800" rows="8" readonly
            class="textarea-c502" autocomplete="off"></textarea>
        </div>
      </ng-container>
    </div>

  </div>
</p-dialog>